<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/k7RnG7/tc-custom/9781783037988.jpg?1728954790224" alt="This image is the cover for the book Foul Deeds & Suspicious Deaths in Nottingham, Foul Deeds & Suspicious Deaths"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Foul Deeds & Suspicious Deaths in Nottingham, Foul Deeds & Suspicious Deaths
      </h1>
      <p class="bookDescription body article font2">
        <p>Foul Deeds and Suspicious Deaths in Nottingham' is part of the new established series by Wharncliffe Books. Covering the period 1830 –1950, the book examines murder and suspicious deaths in and around the city of Nottingham and what impact they had on the people of the city.Murder, mystery and suspicious deaths are often considered to be the province of the fiction writer. However, each story contained within 'Foul Deeds and Suspicious Deaths in Nottingham' is a true account of real events that had a serious impact upon all the lives of those involved. These are stories that once shocked, horrified and captivated, the people of Nottingham as they followed the unfolding events through the pages of the newspapers that hit their doormats each evening. From the strange and macabre to murder and mystery this book examines those cases. Analysing both motive and consequence alongside the social conditions prevalent at the time. It is a fascinating insight into a less well known period of Nottingham's past.Take a journey into the darker and unknown side of your area as you read 'Foul Deeds and Suspicious Deaths in Nottingham'.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kevin Turton
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wharncliffe
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4372acb6